'use strict';

class Feature {
    constructor(node) {
        this.isMounted = false;
        this.node = node;
    }
    update() { }
}

exports.Feature = Feature;
//# sourceMappingURL=Feature.cjs.map
